import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { strings } from "../../localization";
import Banner from "../Banner";
import BannerDesktop from "../../assets/images/home-banner-desktop.png";
import BannerMobile from "../../assets/images/home-banner-mobile.png";
import { useAnalytics } from "../../hooks";
import { getFFBigPayLuck } from "../../services/SystemConfiguration";

export const HeroSection: React.FC = () => {
	const {
		components: { heroSection },
	} = strings;
	const { addAnalyticEvent } = useAnalytics();
	const [ffFGTSBigPay, setFgtsBigPayLuck] = useState<boolean>(false);

	const onTriggerTagging = (): void => {
		addAnalyticEvent({
			component: "body",
			action: "click:banner",
			step: "home:banner-topo",
			description: heroSection.title(false),
		}, {
			applySanitize: true,
		});
	};

	// busca valor da ff FGTSBigPayLuck memorize retorno
	const fetchFeatureFlag = useCallback(async (): Promise<void> => {
		const ffFGTSBigPayLuck = await getFFBigPayLuck();
		setFgtsBigPayLuck(ffFGTSBigPayLuck);
	}, []);

	useEffect(() => {
		fetchFeatureFlag();
	}, []);

	return (
		<Box width="100%" paddingTop="56px" paddingX="24px">
			<Banner
				desktopImg={BannerDesktop}
				mobileImg={BannerMobile}
				info={{
					heading: {
						children: heroSection.title(false),
						fontSize: { base: "24px", lg: "46px" },
						lineHeight: { base: "32px", lg: "48px" },
						fontWeight: { base: "700", lg: "400" },
					},
					description: {
						children: <p>{heroSection.description(ffFGTSBigPay)}</p>,
						fontSize: { base: "16px", lg: "22px" },
						lineHeight: { base: "24px", lg: "28px" },
						maxW: "100%",
						fontWeight: "300",
					},
					infoBox: {
						maxWidth: { base: "279px", lg: "590px" },
					},
					smallTitle: "ANTECIPAÇÃO DE FGTS",
				}}
				button={{ title: heroSection.button, link: "/login", borderRadius: "999px" }}
				bgPosition={{ base: "right center", lg: "right top" }}
				height={{ base: "580px", lg: "360px" }}
				width="100%"
				maxWidth="1224px"
				margin="auto"
				taggingStep="home:banner-topo:solicitacao"
				onClick={onTriggerTagging}
			/>
		</Box>
	);
};
